export const provinceOptions = [
  {
    value: 'BC',
    label: 'British Columbia',
  },
  {
    value: 'AB',
    label: 'Alberta',
  },
  {
    value: 'SK',
    label: 'Saskatchewan',
  },
  {
    value: 'MB',
    label: 'Manitoba',
  },
  {
    value: 'ON',
    label: 'Ontario',
  },
  {
    value: 'QC',
    label: 'Quebec',
  },
  {
    value: 'NB',
    label: 'New Brunswick',
  },
  {
    value: 'NS',
    label: 'Nova Scotia',
  },
  {
    value: 'PE',
    label: 'Prince Edward Island',
  },
  {
    value: 'NL',
    label: 'Newfoundland and Labrador',
  },
  {
    value: 'YT',
    label: 'Yukon',
  },
  {
    value: 'NT',
    label: 'Northwest Territories',
  },
  {
    value: 'NU',
    label: 'Nunavut',
  },
];
